// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"33b6cb1c","598":"728fb01e","703":"e2fb6e2e","787":"d8fb17d1"}[chunkId] + ".chunk.js";
};